var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppBarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.998,
    height: 50,
    viewBox: "0 0 200.998 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_Bar_Logo",
    "data-name": "App Bar Logo",
    transform: "translate(-387.096 -225.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-256.793 -74.008)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Entertainment_Park",
    "data-name": "Entertainment Park",
    transform: "translate(716.887 338)",
    fill: "#5e553d",
    fontSize: 10,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Entertainment Park")), /*#__PURE__*/React.createElement("text", {
    id: "Cloud_forest",
    "data-name": "Cloud forest",
    transform: "translate(716.887 325)",
    fill: "#5e553d",
    fontSize: 16,
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLOUD FOREST"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-675.02 -295.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-21540.135-23917.633a13.142,13.142,0,0,1-8.9,2.084c-4.127-.492-10.027-3.545-10.717-9.689a13.074,13.074,0,0,1,3.514-11.15c2.691-3.143,10.506-3.105,10.506-3.105s5.822-9.383,16.6-8.168,11.438,8.168,11.438,8.168,12.477-.986,14.344,8.125-.791,12.59-6.936,14.871-11.967-1.135-11.967-1.135a17.593,17.593,0,0,1-8.824,2.627A22.915,22.915,0,0,1-21540.135-23917.633Z",
    transform: "translate(22621.996 24469)",
    fill: "#14b72a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(1072.959 536.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-21532-23869.607h29.936l-10.391-.969s-2.154-9.307-.643-14.029c.68-2.111,3.762-5.025,5.162-8.814a19.508,19.508,0,0,0,1.172-8.264,26.476,26.476,0,0,1-2.738,7.535,22.93,22.93,0,0,1-4.408,5.1,23.562,23.562,0,0,1-4.055-3.713,37.849,37.849,0,0,1-3.535-5.412s1.162,2.807,2.252,5.412c1.006,2.406,2.209,3.313,2.049,4.674-.311,2.709-2.969,9.111-3.2,11.59a45.75,45.75,0,0,0,0,5.92Z",
    transform: "translate(21531.996 23904.463)",
    fill: "#5e553d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-21516.24-23897.723l-2.105-3.734a8.216,8.216,0,0,0-2.289-5.09,8.754,8.754,0,0,0-4.66-2.277,20.052,20.052,0,0,1,4.211,3.236,7.247,7.247,0,0,1,1.719,3.145l-5.93-1.057a33.708,33.708,0,0,1,5.449,2.691A24.453,24.453,0,0,1-21516.24-23897.723Z",
    transform: "translate(21527.9 23908.824)",
    fill: "#5e553d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-21468.77-23885.965l-.457.869,3.543-.869s2.623.8,3.994.307a21.152,21.152,0,0,0,3.3-1.738,20.628,20.628,0,0,1-3.609,1.059,9.09,9.09,0,0,1-2.949,0l3.262-2.959-4.5,2.441Z",
    transform: "translate(21493.639 23896.889)",
    fill: "#5e553d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1121.447,564.361l.4,9.191.9,1.491a43.152,43.152,0,0,0,0-6.778A8.269,8.269,0,0,0,1121.447,564.361Z",
    transform: "translate(-1109.218 -562.733)",
    fill: "#5e553d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBarLogo);
export default __webpack_public_path__ + "static/media/AppBarLogo.ea3a7d2f4e6a89ba49b5abbfa9239433.svg";
export { ForwardRef as ReactComponent };